import request from "../utils/http";
// import axios from "./httpp"
import { baseUrl } from "@/config/project";
import qs from "qs";

/* 登录 */
// 登录
export function login(param) {
  return request({
    url: "/login",
    // url: "/v1/auth/login",
    method: "post",
    data: param,
  });
}
export function getUserPermissionList(param) {
  return request({
    url: "/getUserPermissionList",
    // url: "/v1/auth/login",
    method: "get",
    params: param,
  });
}
/* 基站管理 */
// 基站管理-获取基站列表
export function getStations(param) {
  return request({
    url: "/getStations",
    method: "get",
    params: param,
  });
}
// 基站管理-获取基站组列表
export function getStaGroupNameList(param) {
  return request({
    url: "/getStaGroupNameList",
    method: "get",
    params: param,
  });
}
// 基站管理-获取基站组下拉基站列表
export function getStaGroupStasList(param) {
  return request({
    url: "/getStaGroupStasList",
    method: "get",
    params: param,
  });
}
// 基站管理-删除基站
export function delStation(param) {
  return request({
    url: "/delStation",
    method: "get",
    params: param,
  });
}
// 基站管理-新增基站
export function addStation(param) {
  return request({
    url: "/addStation",
    method: "post",
    data: param,
  });
}
// 基站管理-新增基站组
export function addStaGroup(param) {
  return request({
    url: "/addStaGroup",
    method: "post",
    data: param,
  });
}
// 基站管理-编辑基站
export function updateStation(param) {
  return request({
    url: "/updateStation",
    method: "post",
    data: param,
  });
}
// 基站管理-编辑基站组
export function updateStaGroup(param) {
  return request({
    url: "/updateStaGroup",
    method: "post",
    data: param,
  });
}
// 基站管理-删除基站组
export function deleteStaGroup(param) {
  return request({
    url: "/deleteStaGroup",
    method: "post",
    data: param,
  });
}
/* Ntrip用户管理 */
// Ntrip用户管理-获取Ntrip用户信息列表
export function getNtripUsers(param) {
  return request({
    url: "/getNtripUsers",
    method: "get",
    params: param,
  });
}
// Ntrip用户管理-获取基站名称列表
export function getBaseNames(param) {
  return request({
    url: "/getBaseNames",
    method: "get",
    params: param,
  });
}
// Ntrip用户管理-新增用户
export function addUsers(param) {
  return request({
    url: "/addUser",
    method: "post",
    data: param,
  });
}
// Ntrip用户管理-编辑用户
export function updateUser(param) {
  return request({
    url: "/updateUser",
    method: "post",
    data: param,
  });
}
// Ntrip用户管理-删除用户
export function delUser(param) {
  return request({
    url: "/delUser",
    method: "get",
    params: param,
  });
}
/* 在线Ntrip用户 */
// 在线Ntrip用户-获取用户列表
export function getUsers(param) {
  return request({
    url: "/getUsers",
    method: "get",
    params: param,
  });
}
/* 登录用户管理*/
// 登录用户管理-用户登录列表
export function getLoginUsers(param) {
  return request({
    url: "/getLoginUsers",
    method: "get",
    params: param,
  });
}
// 登录用户管理-获取角色列表
export function getUserRoleList(param) {
  return request({
    url: "/getUserRoleList",
    method: "get",
    params: param,
  });
}
// 登录用户管理-删除用户
export function delLogin(param) {
  return request({
    url: "/delLogin",
    method: "get",
    params: param,
  });
}
// 登录用户管理-新增用户
export function addLogin(param) {
  return request({
    url: "/addLogin",
    method: "post",
    data: param,
  });
}
// 登录用户管理-编辑用户
export function updateLogin(param) {
  return request({
    url: "/updateLogin",
    method: "post",
    data: param,
  });
}
/* 站点地图 */
export function getJson(param) {
  return request({
    url: `https://api.mapbox.com/geocoding/v5/mapbox.places/${param.name}.json?access_token=pk.eyJ1IjoicHJiZnVuIiwiYSI6ImNraG9qdG5xdTAxZTUycW9zazdjdmdmbjAifQ.llOJR2h6xEzC3OqurYo6rw`,
    method: "get",
    params: param,
  });
}
// 站点地图-更新半径
export function updateStationRadius(param) {
  return request({
    url: "/updateStationRadius",
    method: "post",
    data: param,
  });
}











/*********************************************/
// 获取数据推送厂商设备列表
export function getDeviceList(param) {
  return request({
    url: "/v1/device_push/list",
    method: "get",
    params: param,
  });
}
//  获取数据推送厂商列表
export function getThirdList(param) {
  return request({
    url: "/v1/third_push/list",
    method: "get",
    params: param,
  });
}
// 批量删除第三方推送厂商
export function batchDeleteThird(param) {
  return request({
    url: "/v1/third_push/delete",
    method: "post",
    data: param,
  });
}
// 批量删除设备
export function batchDeleteDevice(param) {
  return request({
    url: "/v1/device_push/delete",
    method: "post",
    data: param,
  });
}
// 给第三方推送厂商添加设备
export function addThirdDevice(param) {
  return request({
    url: "/v1/device_push/add",
    method: "post",
    data: param,
  });
}
// 新增第三方推送厂商
export function addThird(param) {
  return request({
    url: "/v1/third_push/add",
    method: "post",
    data: param,
  });
}

export function createOrg(param) {
  return request({
    url: "/v1/auth/addOrg",
    // url: "/v1/login_admin",
    method: "post",
    data: param,
  });
}

// 获取所有机构列表
export function queryOrgInfo(param) {
  return request({
    url: "/v1/auth/queryOrgInfo",
    method: "get",
    params: param,
  })
}
// 创建机构
export function addOrg(param) {
  return request({
    url: "/v1/addOrg",
    method: "post",
    params: param,
  });
}
// 编辑机构
export function editOrg(param) {
  return request({
    url: "/v1/auth/editOrg",
    method: "post",
    data: param,
  });
}
// 机构名称是否重复
export function checkOrgName(param) {
  return request({
    url: "/v1/auth/orgIsExist",
    method: "get",
    params: param,
  });
}
// 删除机构
export function removeOrg(param) {
  return request({
    url: "/v1/auth/removeOrg",
    method: "post",
    data: param,
  });
}
/**
 * 内部开放平台权限相关接口如下
 */
// 用户管理-列表
export function queryUserInfo(param) {
  return request({
    url: "/v1/auth/queryUserInfo",
    method: "post",
    data: param,
  });
}
// 用户管理-冻结账号
export function freezeAccount(param) {
  return request({
    url: "/v1/auth/freezeAccount",
    method: "post",
    data: param,
  });
}
// 用户管理-解冻账号
export function unfreezeAccount(param) {
  return request({
    url: "/v1/auth/unFreezeAccount",
    method: "post",
    data: param,
  });
}
// 用户管理-新增用户
export function addUser(param) {
  return request({
    url: "/v1/auth/addUser",
    method: "post",
    data: param,
  });
}
// 用户管理-编辑用户
export function editUser(param) {
  return request({
    url: "/v1/auth/editUser",
    method: "post",
    data: param,
  });
}
// 角色管理-角色列表
export function roleList(param) {
  return request({
    url: "/v1/auth/roleList",
    method: "get",
    params: param,
  });
}
// 角色管理-菜单查询
export function queryMemu(param) {
  return request({
    url: "/v1/auth/queryMenu",
    method: "get",
    params: param,
  });
}
// 角色管理-新增角色
export function addRole(param) {
  return request({
    url: "/v1/auth/roleAdd",
    method: "post",
    data: param,
  });
}
// 角色管理-编辑角色
export function editRole(param) {
  return request({
    url: "/v1/auth/editRole",
    method: "post",
    data: param,
  });
}
// 角色管理-删除角色
export function removeRole(param) {
  return request({
    url: "/v1/auth/removeRole",
    method: "post",
    data: param,
  });
}
